export function formatNumber(v: number) {
  const total = Math.floor(v * 100);

  return total;
}
